import { createConsentAccountApi, isValidOrgCode, resolveCortexUrl } from 'libs.consent.react';
// Cortex object ids. The document id arrives in a link from an email and is
// interpolated into a request path, so it is pattern-checked rather than
// forwarded as-is.
const SIGNED_DOCUMENT_ID_PATTERN = /^[0-9a-f]{24}$/;
export const isValidSignedDocumentId = (documentId) => SIGNED_DOCUMENT_ID_PATTERN.test(documentId);
/**
 * Validates the raw URL inputs of the consent-document route and, if they check
 * out, builds the Cortex client needed to resolve where the signer should land.
 * Returns `null` for any malformed or unrecognized input, which the caller
 * renders as an invalid-link state without making a request.
 *
 * Deliberately narrower than {@link resolveConsentInviteContext}: this route
 * carries no invite token, so there is nothing to decode and no signer identity
 * to cross-check. The signer authenticates against Lumos and Cortex ACLs gate
 * the document read.
 */
export const resolveConsentDocumentContext = ({ documentId, orgCode, environmentKey, }) => {
    const cortexUrl = resolveCortexUrl(environmentKey);
    if (!isValidSignedDocumentId(documentId) || !isValidOrgCode(orgCode) || !cortexUrl) {
        return null;
    }
    return {
        accountApi: createConsentAccountApi(cortexUrl, orgCode),
        documentId,
        environmentKey,
        orgCode,
    };
};
